
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import { Paper, Stack, Typography, Box, Button, PaginationItem, Pagination, OutlinedInput } from '@mui/material';
import axiosInstance from '../Service/apiservice';
import AlertModal from '../Component/modal';




let deleteModalDatas = {
    label: 'Confirm to delete company permanently',
    descriptionOne: 'Are you want delete company ?',
    buttonOne: {
        variant: 'outlined',
        color: '#0E5E84',
        backgroundColor: '#FFFFFF',
        text: 'Cancel'
    },
    buttonTwo: {
        variant: 'contained',
        color: '#FFFFFF',
        backgroundColor: '#B42318',
        text: 'Delete'
    },
}

export default function List() {
    const navigate = useNavigate()

    const [data, setdata] = useState([])
    const [paginationData, setPaginationData] = useState({})

    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState('5')
    const [deleteId, setDeleteId] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)

    useEffect(() => {

        getCompany()

    }, [currentPage])

    const getCompany = async () => {
        try {
            const response = await axiosInstance.get(`https://bsmartsg.com/backend/api/company`)
            console.log(response);
            setdata(response?.data?.data?.companies)
            setPaginationData(response?.data?.data?.pagination_details)
        }
        catch (err) {
            console.log(err);
        }
    }

    const DeleteData = async () => {

        try {
            const response = await axiosInstance.delete(`https://bsmartsg.com/backend/api/company/${deleteId}`)
            console.log(response);
            getCompany()
            setDeleteModal(false)


        } catch (error) {
            console.log(error);
        }
    }

    const closeModal = () => {
        setDeleteModal(false)
        setDeleteId('')
    }

    return (<>

        {deleteModal && <AlertModal modalDatas={deleteModalDatas} confirmFunction={DeleteData} closeFunction={closeModal} />}

        <Box display='flex' justifyContent='space-between'>
            <h2 textAlign='start'>Company List</h2>
            <Button variant='contained' sx={{ height: '40px', backgroundColor: '#3AA6B9', color: 'white' }} onClick={() => navigate('AddCompany')}>Add</Button>
        </Box>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} >
                <TableHead>
                    <TableRow>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}>Logo</Typography></TableCell>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}>Company Name</Typography></TableCell>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}>Slug</Typography></TableCell>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}>Domain</Typography></TableCell>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}>Status</Typography></TableCell>
                        <TableCell><Typography sx={{ fontSize: "1.1rem", fontWeight: "500 !important" }}></Typography></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((itm, index) => {
                        return (
                            <TableRow

                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <img src={`${process.env.REACT_APP_WMS_IMG_BASE_URL}/${itm?.logo}`} alt="" width="70px" height="70px" style={{ objectFit: 'cover' }} />
                                </TableCell>
                                <TableCell ><Typography sx={{ fontSize: "1rem", fontWeight: "500 !important" }}>{itm?.company_name}</Typography></TableCell>
                                <TableCell ><Typography sx={{ fontSize: "1rem", fontWeight: "500 !important" }}>{itm?.slug}</Typography></TableCell>
                                <TableCell ><Typography sx={{ fontSize: "1rem", fontWeight: "500 !important" }}>{itm?.domain}</Typography></TableCell>
                                <TableCell ><Typography sx={{ fontSize: "1rem", fontWeight: "500 !important" }}>{itm?.status_details?.name}</Typography></TableCell>

                                <TableCell width='100px'>
                                    <Stack direction='row' gap={2} width='fit-content'>
                                        <Button onClick={() => { navigate(`EditCompany/${itm?.id}`) }} pr={2} sx={{ border: ' 1px solid #009CA6', color: "#009CA6s" }}>Edit</Button>
                                        <Button variant='contained' sx={{ backgroundColor: '#9A4444 !important' }} onClick={() => { setDeleteId(itm?.id); setDeleteModal(true) }}>Delete</Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Box sx={{ backgroundColor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '0px 0px 8px 8px', display: 'flex', alignItems: 'center', justifyContent: 'end', p: 2.5 }}>
                <Pagination page={currentPage} size='large' count={Math.ceil(paginationData?.total / paginationData?.per_page)} onChange={(e, value) => setCurrentPage(value)} renderItem={(item) => (
                    <PaginationItem
                        // slots={{ previous: PreviousIcon, next: NextIcon }}
                        {...item}
                    />
                )}
                />
            </Box>
        </TableContainer>

    </>
    )
}
